import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LanguageService } from 'src/app/Shared/services/language/language.service';
import { DEFAULT_LOCALE, isValidLocale } from './locale.constants';

const TWO_LETTER_LOCALE_PATTERN = /^[a-z]{2}$/i;

export const localeGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const router = inject(Router);
  const languageService = inject(LanguageService);
  const parsedUrl = router.parseUrl(state.url);
  const primarySegments = parsedUrl.root.children['primary']?.segments ?? [];
  const rawLocale = primarySegments[0]?.path?.toLowerCase() ?? '';

  if (!isValidLocale(rawLocale)) {
    return buildRedirectTree(
      router,
      state.url,
      primarySegments.map((segment) => segment.path)
    );
  }

  languageService.setLanguageFromLocaleCode(rawLocale);
  return true;
};

function buildRedirectTree(
  router: Router,
  currentUrl: string,
  segments: string[]
): UrlTree {
  const parsedUrl = router.parseUrl(currentUrl);
  const [firstSegment, ...restSegments] = segments;

  if (!firstSegment) {
    return router.createUrlTree([DEFAULT_LOCALE], {
      queryParams: parsedUrl.queryParams,
      fragment: parsedUrl.fragment ?? undefined,
    });
  }

  // Invalid locale-like prefixes (/fr/...) drop the prefix.
  // Legacy unprefixed URLs (/buyer/auth/...) are normalized to default locale.
  const redirectSegments = TWO_LETTER_LOCALE_PATTERN.test(firstSegment)
    ? [DEFAULT_LOCALE, ...restSegments]
    : [DEFAULT_LOCALE, ...segments];

  return router.createUrlTree(redirectSegments, {
    queryParams: parsedUrl.queryParams,
    fragment: parsedUrl.fragment ?? undefined,
  });
}
